import React, { Context } from 'react';

import { FullScreenPopupContextType } from '../types/fullScreenPopupContextType.types';

export const FullScreenPopupContext: Context<FullScreenPopupContextType> = React.createContext({ onClose: (): void => undefined });
